import { Injectable } from '@angular/core';
import { LoggingApiService } from './logging-api.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHash } from '@buildium/ngx-app-utility/dist';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { Observable, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { JsErrorDto } from '@root/src/shared/domain/dtos/js-error.dto';

@Injectable()
export class FeatureFlagService {
    private featureFlagCache = new Map<string, Observable<boolean>>();

    constructor(
        private loggingApiService: LoggingApiService,
        private http: HttpClient,
        private errorHash: ErrorHash
    ) {
    }

    retrieveFlag(key: string): Observable<boolean> {
        return this.retrieveFlagCommon(key);
    }

    retrievePublicFlag(key: string): Observable<boolean> {
        return this.retrieveFlagCommon(key, true);
    }

    private retrieveFlagCommon(key: string, isPublic: boolean = false): Observable<boolean> {
        if (!key) {
            const message = 'No feature flag found.';
            const hash = this.errorHash.hashErrorString(message);
            const jsErrorDto: JsErrorDto = {
                message,
                location: window.location.pathname,
                userAgent: window.navigator.userAgent,
                hash,
                callstack: ''
            };
            this.loggingApiService.logError(jsErrorDto);
            return of(false);
        }

        if (!this.featureFlagCache.has(key)) {
            const url = `${BASE_PATH_API}/${isPublic ? 'public' : 'external'}/featureFlags/${key}`;
            const observable = this.http.get<boolean>(url).pipe(
                shareReplay(1)
            );
            this.featureFlagCache.set(key, observable);
        }

        return this.featureFlagCache.get(key);
    }

    isOverrideEnabled(): Observable<boolean> {
        const url = `${BASE_PATH_API}/public/FeatureFlags/settings/overrides/validity`;
        return this.http.get<boolean>(url);
    }
}
